import { useCallback, useState } from 'react';

import type { SafetyLogState } from '../types';

const initialState = (date: string): SafetyLogState => ({
  date,
  items: [],
});

export function useSafetyLogForm(date: string) {
  const [state, setState] = useState<SafetyLogState>(() => initialState(date));
  const [logId, setLogId] = useState<string | null>(null);

  const setField = <K extends keyof SafetyLogState>(field: K, value: SafetyLogState[K]) =>
    setState((prev) => ({ ...prev, [field]: value }));

  const prefillForm = useCallback((next: SafetyLogState, id: string | null) => {
    setState(next);
    setLogId(id);
  }, []);

  const resetForm = useCallback((resetDate: string) => {
    setState(initialState(resetDate));
    setLogId(null);
  }, []);

  return {
    state,
    logId,
    setField,
    setState,
    setLogId,
    prefillForm,
    resetForm,
  };
}
